import { css } from 'lit';

import color from '../../utils/get-color-token';
import getToken from '../../utils/get-token';
import { on, disabled, transition, typography } from '../../styles';

const baseTransitionConfig = {
	delay: '0s',
	duration: '0.35s',
	easing: 'ease-in-out',
};

function styles() {
	return css`
		${on.focus('.check-input-label')} {
			border-radius: 2px;
			outline: 1px solid ${color('color-primary-60')};
		}

		.check-input-label {
			${typography('body-md')};

			gap: ${getToken('spacing-1')};
			align-items: center;
			display: inline-flex;
			padding: 4px 2px;
		}

		.check-input-label,
		.check-input {
			cursor: pointer;
		}

		.check-input {
			--checkbox-input-size: ${getToken('font-size-4')};

			color: ${color('color-text-tertiary')};
			width: var(--checkbox-input-size);
			height: var(--checkbox-input-size);
			background: ${color('color-neutral-0')};
			appearance: none;
			outline: none;
			border-style: solid;
			border-radius: ${getToken('border-radius-s')};
			border-color: ${color('color-border')};
			border-width: ${getToken('border-thin')};
			margin: 0;
			${transition([
				{
					property: 'border',
					...baseTransitionConfig,
				},
				{
					property: 'background',
					...baseTransitionConfig,
				},
			])};
		}

		.check-input:indeterminate,
		.check-input:checked {
			background: ${color('color-primary-60')};
			border-color: ${color('color-primary-60')};
		}

		${disabled('.check-input')} {
			background: ${color('color-background-tertiary')};
			cursor: not-allowed;
		}

		${disabled('.check-input:indeterminate')},
		${disabled('.check-input:checked')} {
			background: ${color('color-neutral-40')};
			border-color: ${color('color-neutral-40')};
		}

		${on.hover('.check-input:indeterminate')},
		${on.hover('.check-input:checked')} {
			background: ${color('color-primary-100')};
			border-color: ${color('color-primary-100')};
		}

		${on.hover('.check-input')} {
			border-color: ${color('color-primary-100')};
		}

		:host([disabled]) .check-input-label {
			cursor: not-allowed;
			color: ${color('color-text-disabled')};
		}

		.check-icon,
		.indeterminate-icon {
			--m-icon-size: 1em;
			--m-icon-color: ${color('color-neutral-0')};

			position: absolute;

			pointer-events: none;
			border-width: ${getToken('border-thin')};
			border-style: solid;
			border-color: transparent;
			border-radius: ${getToken('border-radius-s')};
			display: none;
		}

		.check-input:checked:not(:indeterminate) ~ .check-icon,
		.check-input:indeterminate:not(:checked) ~ .indeterminate-icon {
			display: inline-flex;
		}
	`;
}

export default styles;
